import { render, staticRenderFns } from "./SpecieDetailView.vue?vue&type=template&id=79c23603&"
import script from "./SpecieDetailView.vue?vue&type=script&lang=js&"
export * from "./SpecieDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports